import { motion, useScroll, useSpring } from "framer-motion";

// Thin welding-green progress bar pinned to the top of the viewport.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-0.5 origin-left bg-weld shadow-[0_0_12px_rgba(107,255,61,0.8)]"
    />
  );
};
